export const currentStepSelector = state => state.step.current || {};
export const maxStepSelector = state => state.step.max || {};
